import type { IconAliases } from './icons';

const aliases: IconAliases = {
  itemAdd: 'mdi-plus',
  itemCancel: 'mdi-close',
  itemConfirm: 'mdi-check',
  itemEdit: 'mdi-pencil-outline',
  itemMoveUp: 'mdi-arrow-up',
  itemMoveDown: 'mdi-arrow-down',
  itemDelete: 'mdi-delete',
  search: 'mdi-magnify',
  treeExpand: 'mdi-chevron-right',
  treeCollapse: 'mdi-chevron-down',
  visibilityOff: 'mdi-eye-off',
  visibilityOn: 'mdi-eye',
  calendarClock: 'mdi-calendar-clock',
  clock: 'mdi-clock-outline',
  passwordHide: 'mdi-eye-off',
  passwordShow: 'mdi-eye',
  typeArray: 'mdi-format-list-bulleted',
  typeBoolean: 'mdi-toggle-switch-outline',
  typeNull: 'mdi-null',
  typeNumber: 'mdi-numeric',
  typeObject: 'mdi-folder-outline',
  typeString: 'mdi-format-text',
  typeUnknown: 'mdi-circle-small',
  validationError: 'mdi-alert-circle-outline',
};

export { aliases };
